import React from "react";
import {Box, Typography} from "@mui/material";
import {GridPagination} from "@mui/x-data-grid";

export default function CustomGridFooter(hours: number) {

    const formatHours = (val: number) => {
        const hours = Math.trunc(val / 3600);
        const minutes = Math.round((val - hours * 3600) / 60);
        return hours + ":" + (`0${minutes}`).slice(-2)
    }
    const formatMinutes = (val: number) => {
        return Math.round(val / 60);
    }

    return (
        <Box>
            <Box sx={{p: "16px 16px 0 16px", display: "flex", justifyContent: "flex-end"}}>
                <Box>
                    <Typography variant={"h6"} sx={{textAlign: "right"}}>Seštevek ur: {formatHours(hours)}h</Typography>
                    <Typography variant={"h6"} sx={{textAlign: "right"}}>Seštevek v minutah: {formatMinutes(hours)} min</Typography>
                </Box>
            </Box>
            <Box>
                <GridPagination/>
            </Box>
        </Box>
    );
}